export const FORM_ID = 'cat-in-seg-queryBuilder';
